const routes = [
    {
        path: "/attendance/entry/:sectionId?",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "attendance_getattendanceforsection"
        },
        component_full_path: 'attendanceEntry/pages/Index'
    }
];

export default routes;
